import type { ReactNode } from 'react'

import { InlineNotice } from '@/components/feedback/inline-notice'
import { cn } from '@/lib/cn'

export interface InfoNoticeProps {
  children: ReactNode
  className?: string
  title: string
}

function InfoIcon() {
  return (
    <svg aria-hidden className="size-4" fill="none" viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 7.25v4" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
      <circle cx="8" cy="4.75" fill="currentColor" r="0.75" />
    </svg>
  )
}

export function InfoNotice({ children, className, title }: InfoNoticeProps) {
  return (
    <InlineNotice className={cn('rounded-xl px-4 py-3.5', className)}>
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full bg-[rgba(25,91,255,0.1)] text-[var(--color-primary)]">
          <InfoIcon />
        </span>
        <div className="min-w-0">
          <p className="font-semibold leading-5 text-[var(--color-text)]">{title}</p>
          <div className="mt-1 leading-5 text-[var(--color-text-muted)]">{children}</div>
        </div>
      </div>
    </InlineNotice>
  )
}
